module.exports = __webpack_public_path__ + "../resources/images/SkyCode_26-497d195f709c44ae2eb6268733e9ac5a.svg";